module.exports = __webpack_public_path__ + "static/media/logout-icon.b821908a.svg";